// Featured collection tabs
// ====================================
class Tabs extends HTMLElement {
  constructor() {
    super();
    this.tabControl = this.getAttribute("aria-controls");
    this.tabControlDocument = document.getElementById(this.tabControl);
    this.buttons = [...this.querySelectorAll("button")];
    this.items = [...this.tabControlDocument.querySelectorAll("[tab-item]")];
    this.oldIndex = 0;
    this.buttons.forEach((item) =>
      item.addEventListener("click", () =>
        this.tabChanged(item, this.buttons.indexOf(item))
      )
    );

    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => {
        const targetElement = event.target;
        targetElement.click();
      });
    }
  }

  tabChanged(item, index) {
    if (item.getAttribute("aria-current") === "true") return;
    this.buttons[this.oldIndex].setAttribute("aria-current", "false");
    this.buttons[index].setAttribute("aria-current", "true");
    this.items[this.oldIndex].removeAttribute("tab-selected");
    this.oldIndex = index;
    this.items[index].setAttribute("tab-selected", "");
  }
}

customElements.define("featured-collection-tab", Tabs);

// Featured collection Slider with tabs
// ====================================
class Slider extends HTMLElement {
  constructor(e) {
    super();
    const tabPan = this.querySelectorAll(".slider_activate");
    tabPan.forEach((item) => {
      const blockId = item.getAttribute("data-block-id");
      this.initSwiperSlider(blockId);
    });
  }
  initSwiperSlider(blockId) {
    const slideShowOnXl = this.getAttribute("data-show-extra-large");
    const slideShowOnMobile = this.getAttribute("data-show-mobile");
    const slideAutoplay = this.getAttribute("data-autoplay");
    const slideAutoplayTime = this.getAttribute("data-autoplay-time");
    let autoPlayInit = false;
    if (slideAutoplay === "true") {
      autoPlayInit = { delay: slideAutoplayTime };
    }
    const swiperContainer = document.getElementById(blockId);
    if (!swiperContainer) {
      console.error(`Swiper container with ID ${blockId} not found.`);
      return;
    }
    var featuredCollection = new Swiper(swiperContainer, {
      slidesPerView: slideShowOnXl,
      spaceBetween: 24,
      loop: true,
      autoplay: autoPlayInit,
      navigation: {
        nextEl: `#${blockId} .swiper-button-next`,
        prevEl: `#${blockId} .swiper-button-prev`,
      },
      breakpoints: {
        320: {
          slidesPerView: slideShowOnMobile,
        },
        480: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: slideShowOnXl,
        },
      },
    });

    // console.log("FEEEEEEEEEEEEEEEEE", featuredCollection)
    // console.log("GGGGGGGGGGGGGGGGGGGG", getComputedStyle(featuredCollection))
  }
}

customElements.define("tab-slider", Slider);

// document.addEventListener('DOMContentLoaded', function () {
//  function initSwiperSlider(blockId) {
//     if (blockId) {
//       var featuredCollection = new Swiper(`#${blockId}`, {
//         slidesPerView: 4,
//         spaceBetween: 30,
//         loop: true,
//       });
//     }
//   }

//   function onSectionLoad(event) {
//     const sectionId = event.detail.sectionId;
//     const section = document.querySelector(`[data-section-id="${sectionId}"]`);
//     if (section) {
//       section.querySelectorAll('.tab-pane').forEach(tabPane => {
//         const blockId = tabPane.getAttribute('data-block-id');
//         initSwiperSlider(blockId); // Initialize Swiper for the selected block
//       });
//     }
//   }

//   function onBlockSelect(event) {
//     const blockId = event.detail.blockId;
//     initSwiperSlider(blockId); // Initialize Swiper for the selected block
//   }

//   // Bind Shopify section events
//   document.addEventListener('shopify:section:load', onSectionLoad);
//   document.addEventListener('shopify:section:select', onSectionLoad);
//   document.addEventListener('shopify:block:select', onBlockSelect);

//  // Run the code immediately if the section is already present

//   document.querySelectorAll('[data-section-id]').forEach(section => {
//     section.querySelectorAll('.tab-pane').forEach(tabPane => {
//       const blockId = tabPane.getAttribute('data-block-id');
//       initSwiperSlider(blockId);
//     });
//   });

//  return {
//    initSwiperSlider: initSwiperSlider
// };
// });
